import { mapToObjArr } from 'app/admin/common/util/CommonUtil';
import NamedDto from 'modules/base/dto/NamedDto';
import ModelValidationToleranceEditDto from './ModelValidationToleranceEditDto';
import ModelValidationStateInjectEditDto from './ModelValidationStateInjectEditDto';

export class ModelValidationEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.measurement = null;
		/** @type {number} */
		this.aspect = null;
		/** @type {number} */
		this.modelValidationLog = null;
		/** @type {ModelValidationToleranceEditDto[]} */
		this.tolerances = null;
		/** @type {ModelValidationStateInjectEditDto[]} */
		this.stateInject = null;
		/** @type {number} */
		this.whatIf = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _ModelValidationEditDtoProps
	 * @property {number} measurement
	 * @property {number} aspect
	 * @property {number} modelValidationLog
	 * @property {number} whatIf
	 * @property {ModelValidationToleranceEditDto[]} tolerances
	 * @property {ModelValidationStateInjectEditDto[]} stateInject
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ModelValidationEditDtoProps} ModelValidationEditDtoProps
	 */

	/**
	 *
	 * @param {ModelValidationEditDtoProps} props
	 * @returns {ModelValidationEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.measurement = props.measurement;
		this.aspect = props.aspect;
		this.modelValidationLog = props.modelValidationLog;
		this.whatIf = props.whatIf;
		this.tolerances = props.tolerances !== null ? props.tolerances.map(d => new ModelValidationToleranceEditDto().setup(d)) : [];
		this.stateInject = props.stateInject !== null ? props.stateInject.map(d => new ModelValidationStateInjectEditDto().setup(d)) : [];
		this.userGroup = props.userGroup;

		return this;
	}
}

export default ModelValidationEditDto;